module.exports = __webpack_public_path__ + "img/two2Blue.2167abcd.jpg";